module.exports = __webpack_public_path__ + "img/Maple.49559ef.svg";